<!--
  Ya no hay pestañas aquí dentro. La vista la manda la RUTA —`/cobranza/dinero` o
  `/cobranza/por-atender`— y Cobranza pinta su segmentado arriba: dos niveles de pestañas eran dos
  de las cinco barras de controles que había antes del primer dato.

  La lente «Por pago» se retiró con la pantalla de Aplicaciones (D-04): su único aporte —el desglose
  por concepto— vive en el cajón del pago, donde está pegado al pago del que salió.

  Tampoco se envuelve en `p-card`: la tarjeta la pone Cobranza, y anidar la suya dibujaba una caja
  dentro de otra — el mismo error de las franjas flotantes, un nivel más adentro. Esta vista solo
  existe dentro de Cobranza, así que no hay caso suelto que atender.
-->
<!--
  La tabla de Dinero es propia y NO la genérica: ver `payments-table.component.ts`. La genérica no se
  toca —la usan muchas pantallas—, simplemente deja de usarse aquí.
-->
<!--
  Esta vista provee su PROPIO MessageService (`providers` del componente), así que el <p-toast> de Cobranza
  no recibe sus avisos: necesita el suyo. Se había borrado en 48bf4ac5 y ningún aviso de Dinero se veía.
-->
<p-toast position="top-right"></p-toast>

<app-payments-table
  *ngIf="lens === 'todos'"
  #tablaPagos
  (anular)="openVoidFromList($event)"
  (aplicar)="openApply($event)"
  (registrar)="mainActions('CREATE')"
  (cancelApplication)="openCancelApplication($event)"
  (edit)="openEdit($event)"
></app-payments-table>

<!-- Aplicar un pago o cancelar una de sus aplicaciones sin salir de Cobranza: el mismo diálogo y el
     mismo motor que Exigibilidad. El modo decide a qué endpoint va (F-045). -->
<app-apply-preview-dialog
  #applyDialog
  [(visible)]="showApply"
  [mode]="previewMode"
  [payments]="applyPayments"
  [application]="cancelTarget"
  [leaseId]="applyLeaseId"
  [clientLeases]="applyClientLeases"
  [nextToCollect]="applyNextToCollect"
  [nextToCollectDate]="applyNextToCollectDate"
  [previewing]="applyPreviewing"
  [saving]="applySaving"
  (onPreview)="previewInDialog($event, applyDialog)"
  (onApply)="confirmInDialog($event, applyDialog)"
></app-apply-preview-dialog>

<!-- Evidencia del 409 `POSSIBLE_DUPLICATE`, una sola vez para los dos diálogos que la pintan («Editar pago» y el
     alta). Cada uno pasa su frase final en `closing`: lo que cambia es qué hace la persona con el aviso. -->
<ng-template #twinEvidence let-dup let-closing="closing">
  <div class="pe-dup">
    <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
    <div>
      <strong>Ya existe un pago igual de este cliente en la ventana de duplicados</strong>
      <ul class="pe-dup-list">
        <li *ngFor="let tw of dup.twins">
          <span class="pe-mono">{{ tw.trackingKey }}</span> · {{ tw.amount | currency }} · {{ tw.date | date: 'dd/MM/yyyy' : 'UTC' }} ·
          {{ twinStatusLabel(tw.status)
          }}<span *ngIf="tw.leases?.length"> · {{ tw.leases[0].folio }} letras {{ tw.leases[0].letters.join(', ') }}</span>
        </li>
      </ul>
      <span
        >El cliente tiene {{ dup.activeLeases }} arrendamiento(s) activo(s): la misma renta en cada uno es un caso normal.
        {{ closing }}</span
      >
    </div>
  </div>
</ng-template>

<!-- Corregir monto o clave de rastreo (F-045). Vive aquí y no en un componente propio: es un formulario
     de tres campos y su único consumidor es esta vista. -->
<p-dialog
  [(visible)]="showEdit"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{ width: '520px', maxWidth: '95vw' }"
  styleClass="payment-edit-dialog"
  header="Editar pago"
>
  <div class="pe-body" *ngIf="editTarget as t">
    <div class="pe-summary">
      <span class="pe-label">Pago</span>
      <span class="pe-value"
        >{{ t.monto | currency }} · <span class="pe-mono">{{ t.claveRastreo }}</span></span
      >
      <span class="pe-hint">{{ t.cliente }} · pagó el {{ t.fecha | date: 'dd/MM/yyyy' : 'UTC' }}</span>
    </div>

    <div class="field">
      <label id="pe-amount-label" for="pe-amount">Monto</label>
      <!-- `p-inputNumber` (PrimeNG 16) no expone `aria-describedby`, solo `ariaLabelledBy`: con el monto
           bloqueado, el aviso de abajo entra por ahí para que el lector de pantalla diga por qué. -->
      <p-inputNumber
        inputId="pe-amount"
        [(ngModel)]="editAmount"
        (onInput)="onEditInput()"
        mode="currency"
        currency="MXN"
        locale="es-MX"
        [min]="0.01"
        [maxFractionDigits]="2"
        [disabled]="editAmountLocked"
        [ariaLabelledBy]="editAmountLocked ? 'pe-amount-label pe-amount-help' : 'pe-amount-label'"
        styleClass="w-full"
      ></p-inputNumber>
      <!-- D-1 · regla A: con dinero ya repartido, el monto no se toca. Se dice por qué y cómo seguir. -->
      <small id="pe-amount-help" class="pe-help" *ngIf="editAmountLocked"
        >Este pago tiene {{ t.aplicado | currency }} aplicados. Para corregir el monto, primero cancela sus aplicaciones con «Cancelar
        aplicación» en el detalle del pago.</small
      >
    </div>

    <div class="field">
      <label for="pe-key">Clave de rastreo</label>
      <input id="pe-key" pInputText type="text" class="pe-mono" [(ngModel)]="editTrackingKey" (ngModelChange)="onEditInput()" />
    </div>

    <div class="field">
      <label for="pe-reason">Motivo <span class="pe-req">*</span></label>
      <!-- El error no va solo en color: el texto de abajo cambia y el campo se marca inválido. -->
      <textarea
        id="pe-reason"
        pInputTextarea
        rows="3"
        [(ngModel)]="editReason"
        [autoResize]="true"
        [maxlength]="editReasonMaxLength"
        aria-required="true"
        aria-describedby="pe-reason-help"
        [attr.aria-invalid]="editReasonInvalid"
        placeholder="Ej. El monto se capturó con un cero de más; el estado de cuenta muestra $12,500.00"
      ></textarea>
      <small id="pe-reason-help" class="pe-help" [class.is-error]="editReasonInvalid">
        <ng-container *ngIf="editReasonInvalid; else reasonHint"
          >{{ editReasonMissingText }} para el mínimo de {{ editReasonMinLength }}.</ng-container
        >
        <ng-template #reasonHint>Mínimo {{ editReasonMinLength }} caracteres. Queda en la bitácora del pago, a tu nombre.</ng-template>
      </small>
    </div>

    <!-- Evidencia, no veredicto: se avisa del gemelo y la persona decide (mismo patrón que el alta). -->
    <ng-container *ngIf="editDuplicate as dup">
      <ng-container
        *ngTemplateOutlet="
          twinEvidence;
          context: { $implicit: dup, closing: 'Si guardas de todos modos, el motivo de arriba queda como justificación.' }
        "
      ></ng-container>
    </ng-container>

    <div class="pe-error" *ngIf="editError"><i class="fa-solid fa-triangle-exclamation"></i> {{ editError }}</div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" (click)="showEdit = false" [disabled]="editSaving"></button>
    <button
      *ngIf="!editDuplicate"
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      [disabled]="!canSaveEdit"
      [loading]="editSaving"
      (click)="saveEdit()"
    ></button>
    <button
      *ngIf="editDuplicate"
      pButton
      type="button"
      label="Guardar de todos modos"
      icon="fa-solid fa-check"
      [disabled]="!canSaveEdit"
      [loading]="editSaving"
      (click)="saveEdit(true)"
    ></button>
  </ng-template>
</p-dialog>

<app-payment-attention-tab
  *ngIf="lens === 'atender'"
  #attentionTab
  [data]="attentionData"
  [loading]="attentionLoading"
  [group]="attentionGroup"
  (onSelect)="openAdjust($event)"
  (onReload)="loadAttention()"
></app-payment-attention-tab>

<!-- Ajuste de un pago: anular una carga repetida, cerrar un remanente o deshacer -->
<app-payment-adjust-modal
  #adjustModal
  [(visible)]="showAdjustModal"
  [payment]="selectedAttentionRow"
  [group]="selectedAttentionGroup"
  [previewing]="attentionPreviewing"
  [saving]="attentionSaving"
  (onPreview)="previewAdjust($event, adjustModal)"
  (onApply)="applyAdjust($event, adjustModal)"
  (onLoadContext)="loadContext($event, adjustModal)"
></app-payment-adjust-modal>

<!--Form to create or update a payment-->
<p-dialog
  [(visible)]="createEntity"
  (onHide)="onCreateDialogHidden()"
  [style]="{ width: '1200px', maxWidth: '96vw' }"
  [draggable]="false"
  [resizable]="false"
  [header]="action === 'CREATE' ? 'Nuevo pago' : 'Actualizar pago'"
  [modal]="true"
  styleClass="p-fluid"
>
  <ng-template pTemplate="content">
    <app-payment-form></app-payment-form>

    <!-- B-060 · El posible duplicado se confirma aquí mismo, con el mismo lenguaje que «Editar pago». Antes
         un aviso mandaba a la pestaña Exigibilidad, que obliga a abrir el arrendamiento para registrarlo. -->
    <div class="pe-body mt-3" *ngIf="createDuplicate as dup">
      <ng-container
        *ngTemplateOutlet="
          twinEvidence;
          context: {
            $implicit: dup,
            closing: 'Si cambias el cliente, el monto, la clave o la fecha, el aviso se descarta y se vuelve a revisar al guardar.',
          }
        "
      ></ng-container>

      <div class="field">
        <label for="pc-dup-reason">Motivo para registrarlo de todos modos <span class="pe-req">*</span></label>
        <textarea
          id="pc-dup-reason"
          pInputTextarea
          rows="3"
          [(ngModel)]="createDuplicateReason"
          [autoResize]="true"
          [maxlength]="createDuplicateReasonMaxLength"
          aria-required="true"
          aria-describedby="pc-dup-reason-help"
          placeholder="Ej. Segundo depósito real del cliente, confirmado por teléfono"
        ></textarea>
        <small id="pc-dup-reason-help" class="pe-help">Obligatorio. Queda en la bitácora del pago, a tu nombre.</small>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="hideDialog()"></button>
    <button
      *ngIf="!createDuplicate"
      pButton
      pRipple
      label="Guardar"
      icon="pi pi-check"
      class="p-button-text"
      (click)="saveForm()"
      [disabled]="!paymentService.entity.valid || createSaving"
      [loading]="createSaving"
    ></button>
    <button
      *ngIf="createDuplicate"
      pButton
      pRipple
      label="Guardar de todos modos"
      icon="pi pi-check"
      (click)="saveForm(true)"
      [disabled]="!canConfirmCreateDuplicate"
      [loading]="createSaving"
    ></button>
  </ng-template>
</p-dialog>
<!--End of form to create or update a payment-->
